import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';

import { Center, LogeButtonSlim, IconBig, Black, BlackHeading } from '../../GeneralStyle'
import { withRouter } from "react-router-dom";

import successIcon from '../../../images/icons/tl_check_bewerbung.png'

@inject('bookingStore', 'userStore')

@observer
class BookingSuccess extends Component {
  render() {
    const { me } = this.props.userStore
    const { golfCourse, bookingDate } = this.props.bookingStore
    const mailContent = "?subject=Startzeit reservieren&body=Guten Tag,%0D%0A ich möchte für den " + bookingDate + " meine Startzeit <IHRE STARTZEIT> reservieren.%0D%0AMit freundlichen Grüßen,%0D%0A" + me.lastname
    let iconSize = window.innerWidth < 769 ? window.innerWidth / 4 : 168

    return (
      <div style={{paddingTop: 35, paddingBottom: 35}}>
        <Center marginTop={30} marginBottom={30}>
          <IconBig icon={successIcon} size={iconSize} margin={0} float={"none"} />
        </Center>
        <Center marginTop={30} marginBottom={30}>
          <BlackHeading>VIELEN DANK FÜR IHRE BUCHUNG, {me.genderTitle + " " + me.lastname}!</BlackHeading>
        </Center>
        <Row>
          <Center margin={45}>
            <Black>Wir haben Ihnen eine Bestätigung via Mail sowie gegebenfalls Einladungen an die eingeladenen Personen geschickt, welche getrennt hiervon einen Tag vor Spielantritt den zugehörigen Voucher via Mail erhalten.</Black>
          </Center>
          <Center margin={45} style={{marginTop: 25}}>
            <Black>Sie können <a style={{textDecoration: "underline"}} href={"mailto:"+golfCourse.email+mailContent}>hier</a> direkt eine  <a style={{textDecoration: "underline"}}  href={"mailto:"+golfCourse.email+mailContent}>E-Mail</a> an den {golfCourse.courseName} senden oder direkt anrufen <a style={{textDecoration: "underline"}} href={"tel:"+golfCourse.phone}>{golfCourse.phone}</a> um ihre Startzeit im Golfclub direkt zu reservieren</Black>
          </Center>
          { golfCourse.hotels.length > 0 &&
            <Center margin={45} style={{marginTop: 35}}>
              <BlackHeading>Hotel buchen?</BlackHeading>
              <Black>
                {golfCourse.courseName} bietet ebenfalls Hotelzimmer an.<br />
                Um von exklusiven Angeboten für The-Loge.com Member zu profitieren, <br />buchen Sie zusätzlich Ihr Zimmer bei folgenden Hotels:
                <ul style={{listStyleType: "none"}}>
                { golfCourse.hotels.map(hotel =>
                  <li>
                    {hotel.name} - <span onClick={() => { window.open(hotel.link, "_blank") }} style={{textDecoration: "underline", cursor: "pointer", marginTop: 15 }} >jetzt buchen</span>
                  </li>
                )}
                </ul>
              </Black>
            </Center>
          }
          <Center marginTop={20} marginBottom={30}>
            <LogeButtonSlim
              hoverFontColor={"white"}
              onClick={() => { this.props.closeModal() }}>
              schließen</LogeButtonSlim>
          </Center>
        </Row>
      </div>
    );
  }
}

BookingSuccess.propTypes = {
  bookingStore: MobxPropTypes.observableObject,
  userStore: MobxPropTypes.observableObject
};

export default withRouter(BookingSuccess);



// WEBPACK FOOTER //
// /src/components/internal/BookingModal/BookingSuccess.js